var $ = require('../internals/export');
var of = require('../internals/collection-of');

// `Map.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
$({ target: 'Map', stat: true, forced: true }, {
  of: of
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.map.of.js
// module id = 748
// module chunks = 0